import styled from 'styled-components'

export const WaterInputContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  input[type='time']::-webkit-calendar-picker-indicator {
    filter: invert(100%);
    cursor: pointer;
  }
`
